<div class="px-3 pt-2r pb-5">
  <h1 class="mb-3">{{ 'MANAGED_USERS.MANAGE_USERS' | translate }}</h1>
  <div class="bg-white shadow-sm border-bottom">
    <div class="p-4">
      <h2>{{ 'MANAGED_USERS.MANAGE_USERS_INFO' | translate }}</h2>
      <p class="m-0">{{ 'MANAGED_USERS.MANAGING_INFO' | translate }}</p>
    </div>

    <div class="d-flex p-4 pt-0 justify-content-between">
      <app-navigation-search-input formClasses="no-line-before" inputClasses="ms-0" />

      <button class="btn btn-primary d-flex" [disabled]="!permissionOptions" (click)="onAddUser()">
        <i class="icon ni-add-lg me-2"></i> {{ 'MANAGED_USERS.ADD_USER' | translate }}
      </button>
    </div>

    <div class="pt-2 pb-5 px-4 border-top">
      <app-managed-users-list
        [inputRows]="rows"
        [loading$]="loading$"
        [refresh$]="refresh$"
        [permissionOptions]="permissionOptions"
        (filterEmit)="onFilter($event)"
      />
    </div>
  </div>
</div>
